/**
 * @file Custom Prints related fragments.
 */

import gql from 'graphql-tag';

import { PhotoUrlTypeFields } from './global';
import { AccountAddressFields } from '../../../../graphql/fragments/account';

export const PurchasedCustomPrintDetails = gql`
  fragment PurchasedCustomPrintDetails on PurchasedCustomPrint {
    id
    photos_no
    custom_print_caption_enabled
    custom_print_caption
    order_status
    shipping_enabled
    shipping_purchased
    shipping_required
    name
    custom_print_type
    delivery_type
    shipping_price {
      value
      currency
    }
    custom_print {
      id
      name
      type
      preview_image {
        id
        url
      }
    }
    photos {
      records {
        id
        position
        photo {
          id
          thumbnail_urls {
            ...PhotoUrlTypeFields
          }
        }
      }
    }
    selected_identity {
      id
      matched_photos_extended {
        total
      }
    }
    album {
      id
    }
    identity {
      id
      name
      last_name
    }
    account_address {
      ...AccountAddressFields
    }
    account {
      id
      addresses {
        ...AccountAddressFields
      }
    }
  }
  ${PhotoUrlTypeFields}
  ${AccountAddressFields}
`;

export const AlbumCustomPrintDetails = gql`
  fragment AlbumCustomPrintDetails on AlbumCustomPrint {
    id
    photos_no
    display_order
    custom_print {
      id
      name
      type
      preview_image {
        id
        url
      }
      photos_no
      background_image {
        id
        url
      }
      account {
        id
        logo_image {
          id
          url
        }
      }
    }
    price {
      value
      currency
    }
    discount_price {
      value
      currency
    }
    shipping_price {
      value
      currency
    }
    album {
      id
    }
    shipping_enabled
    shipping_required
  }
`;
